module.exports = __webpack_public_path__ + "static/footer-exa-team-fb4d62fdf3cf21cadfdf194f0301333a.png";